<template>
  <div class="app-tariff-options-overview-wrapper" v-if="loadedContractState && !isSimCardLocked && !hasDunningLevel && !contractTerminated">
    <div class="bookable-tariff-options" v-if="!loading && firstOption || secondOption">
      <h3><slot name="txtHeadline">Lorem, ipsum.</slot></h3>
      <div class="app-tariff-options-list">
        <div class="tariff-options-wrapper" :class="{'single-option': !firstOption || !secondOption}">
          <div v-if="firstOption" class="tariff-options-column">
            <TariffOptionBox
              :option="firstOption"
              :in-overview="inOverview"
              :disabled="firstOption.isDisabledOptionBox"
            >
              <template v-for="boxSlot in possibleChildSlotsFor('TariffOptionBox')" v-slot:[`${boxSlot.child}`]>
                <slot :name="`${boxSlot.parent}`"></slot>
              </template>
              <template v-for="slot in possibleChildSlotsFor('TariffOptions', firstOption.tariffoptionId)" v-slot:[`${slot.child}`]>
                <slot :id="firstOption.tariffoptionId" :name="`${slot.parent}`"></slot>
              </template>
            </TariffOptionBox>
          </div>
          <div v-if="secondOption" class="tariff-options-column">
            <TariffOptionBox
              :option="secondOption"
              :in-overview="inOverview"
              :disabled="secondOption.isDisabledOptionBox"
            >
              <template v-for="boxSlot in possibleChildSlotsFor('TariffOptionBox')" v-slot:[`${boxSlot.child}`]>
                <slot :name="`${boxSlot.parent}`"></slot>
              </template>
              <template v-for="slot in possibleChildSlotsFor('TariffOptions', secondOption.tariffoptionId)" v-slot:[`${slot.child}`]>
                <slot :id="secondOption.tariffoptionId" :name="`${slot.parent}`"></slot>
              </template>
            </TariffOptionBox>
          </div>
        </div>
      </div>
      <div v-if="!contractTerminated && !contractPauseActive" class="cta"><slot name="txtCta">Lorem, ipsum.</slot></div>
      <div v-if="showError" v-html="errorMsg" class="error-box"></div>
    </div>
  </div>
</template>

<script>
import { wrapQuery } from '@/helper/wrapGQLQuery'
import gql from 'graphql-tag'
import TariffOptionBox from '@/components/process/generic/Tariff/TariffOptionBox.vue'
import transaction from '@/mixins/transaction'
import { splitError } from '@/helper/splitError'
import customerContractState from '@/mixins/customerContractState'
import beErrors from '@/mixins/beErrors'

export default {
  name: 'TariffOptionsOverviewWrapper',
  data () {
    return {
      loading: true,
      showError: false,
      errorMsg: '',
      tariffoptions: {
        bookableTariffoptions: {
          bookableTariffoptions: []
        },
        bookedTariffoptions: {
          bookedTariffoptions: []
        }
      }
    }
  },
  components: {
    TariffOptionBox
  },
  props: {
    inOverview: {
      type: Boolean,
      default: false
    }
  },
  mixins: [
    transaction('tariffOptions'),
    customerContractState(),
    beErrors
  ],
  watch: {
    '$store.state.tariffOptions.bookedOptionUpdateTriggerValue': function () {
      this.$apollo.queries.tariffoptions.refetch()
    }
  },
  computed: {
    optionlist: function () {
      let optionlist = []
      if (!this.contractTerminated) {
        optionlist = this.tariffoptions.bookedTariffoptions.bookedTariffoptions.filter(
          tariffOption => tariffOption.automaticExtension
        )
      }
      if (!this.contractTerminated && !this.contractPauseActive) {
        optionlist = optionlist.concat(this.tariffoptions.bookableTariffoptions.bookableTariffoptions)
      }

      optionlist.forEach(option => {
        option.disabled = this.contractTerminated || this.contractPauseActive
        option.disabledInfo = ''
        if (option.disabled) {
          option.disabledInfo = this.$slots.pausedTariffInfoTxt[0].text
        }
        option.isDisabledOptionBox = option.disabled
        option.isBookableOptionBox = true
      })

      return optionlist || []
    },
    firstOption: function () {
      return this.findOption(this.getSlotText('lblFirstOptionList')) || null
    },
    secondOption: function () {
      return this.findOption(this.getSlotText('lblSecondOptionList')) || null
    }
  },
  methods: {
    findOption (optionIds) {
      const optionIdList = optionIds.split(',') || []

      if (!this.optionlist || this.optionlist.length < 1 || optionIdList.length < 1) {
        return null
      }

      let retOption = null
      let currentIndex = -1

      this.optionlist.forEach(option => {
        const index = optionIdList.findIndex(el => el === option.tariffoptionId)
        if (index >= 0 && (currentIndex === -1 || currentIndex > index)) {
          retOption = option
          if (option.statusKey !== undefined && ['CDL', 'CAN', 'TER'].includes(option.statusKey)) {
            currentIndex = 0
          } else {
            currentIndex = index
          }
        }
      })

      return retOption
    }
  },
  apollo: {
    tariffoptions: function () {
      return wrapQuery(
        gql`query tariffOptions {
           tariffoptions {
            bookedTariffoptions {
              bookedTariffoptions {
                automaticExtension
                tariffoptionId
                name
                details
                price
                formattedPrice
                statusKey
                revocable
                group
                activeRuntime {
                  endOfRuntime
                  startOfRuntime
                }
                duration {
                  amount
                  unit
                  formattedUnit
                }
                volumes {
                  formattedUnit
                  type
                  amount
                  unit
                }
                expirationDate
              }
            }
            bookableTariffoptions {
              bookableTariffoptions {
                automaticExtension
                conflictWithCurrent
                tariffoptionId
                price
                formattedPrice
                name
                details
                group
                duration {
                  amount
                  unit
                  formattedUnit
                }
                volumes {
                  formattedUnit
                  type
                  amount
                  unit
                }
              }
            }
          }
        }`, this, 'tariffoptions', {}, () => {
          this.loading = false
          this.showError = false
          this.errorMsg = ''
        },
        {
          fetchPolicy: 'cache-first'
        },
        (error) => {
          this.loading = false
          this.errorMsg = this.beErrorGetLastMessage()
          if (this.errorMsg === '') {
            splitError(error).forEach(e => {
              this.errorMsg = e.message
            })
          }
          this.showError = true
        }
      )
    }
  }
}
</script>
